import type { SVGProps } from 'react';
const SvgExposurePlus1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#exposure_plus_1_svg__a)">
      <path
        fill="currentColor"
        d="M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7Zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13Z"
      />
    </g>
    <defs>
      <clipPath id="exposure_plus_1_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExposurePlus1;
